import { ReactNode } from "react";

export function fallbackString(
  str?: string | null | undefined,
  placeholder?: ReactNode,
): string | ReactNode {
  return str || placeholder || "-";
}
